import { useInView } from "react-intersection-observer";

export const AnimationTrigger = ({
    children,
    rootMargin = "-100px",
    animation,
    startClass = "",
    triggerOnce = false,
    className,
    style}) => {
    const { ref, inView } = useInView({
      rootMargin: rootMargin,
      triggerOnce: triggerOnce
    });
    return (
        <div ref={ref} className={className} style={style}>
            <div className={inView ? animation : startClass }>{children}</div>
        </div>
    )
}

export const FadeInContainer = ({component}) => {
    return (
        <AnimationTrigger animation="fadeIn">
        <div
          style={{
            justifyContent: "center",
            alignItems: "center",
            margin: "auto",
          }}
        >
            {component}
        </div>
      </AnimationTrigger>
    );
}

export const SlideInLeft = ({component}) => {
    return (
        <AnimationTrigger animation="SlideInLeft">
        <div
          style={{
            justifyContent: "center",
            alignItems: "center",
            margin: "auto",
          }}
        >
            {component}
        </div>
      </AnimationTrigger>
    );
}

export const CustomAnimationTrigger = ({
  children,
  rootMargin = "-100px",
  animation,
  startClass = "",
  triggerOnce = false,
  className,
  style}) => {
  const { ref, inView } = useInView({
    rootMargin: rootMargin,
    triggerOnce: triggerOnce
  });
  return (
      <div ref={ref} className={className}>
          <div className={inView ? animation : startClass } style={inView ? style : null}>{children}</div>
      </div>
  )
}

export const TypingText = ({text, wrapper, className}) => {
  const CustomTag = wrapper;
  const textLength = text.length*2;
  const duration = 0.1 * textLength / 2;
  return (
    <CustomAnimationTrigger
      className={`typing-text ${className}`}
      style={{ 
        width: `${textLength}ch`,
        animation: `typing ${duration}s steps(${textLength})`
      }}
    >
      <CustomTag>{text}</CustomTag>
    </CustomAnimationTrigger>
  );
}
